import { Kbd } from '../Kbd';

export function PowerSearchShortcut() {
  return navigator?.userAgent?.toLowerCase().includes('mac') ? <Kbd>⌘ K</Kbd> : <Kbd>Ctrl K</Kbd>;
}
